<template>
  <div class="mt-4">
    <div class="row mb-4">
      <div class="col-md-9">
        <b-card class="mb-4 shadow-sm">
          <div class="mb-0">
            <div class="col">
              <SimulationLotNavigation
                :lots="simulationLots"
                :show-general-tab="true"
                :use-value-property="false"
                general-tab-label="simulationConstruction.general"
                :general-tab-index="-1"
                :current-section.sync="currentLot"
              />
            </div>
          </div>

          <b-form v-unsave-detector @submit.stop.prevent="onSubmit">
            <b-container fluid>
              <b-row>
                <b-col v-if="currentLot === -1">
                  <div v-for="typeConstruction in typesConstruction">
                    <div class="row my-2">
                      <div class="col-md-12">
                        <span class="section-subtitle">{{ $t(typeConstruction.text) }}</span>
                      </div>
                    </div>

                    <template v-for="simulationConstruction in simulationConstructions">
                      <div
                        v-if="((simulationConstruction.data.simulation != null && simulationConstruction.data.simulation.id === simulationId) || ( simulationConstruction.selectedLots.length !== 0)) && simulationConstruction.data.typeConstruction.value === typeConstruction.value">
                        <simulation-construction-component
                          :simulation-construction="simulationConstruction.data"
                          :index="index"
                          :is-operation-linked="isOperationLinked"
                          :operation-id="operationId"
                          @didChangeValue="emitChangeValue"
                          @removedSimulationConstruction="removedSimulationConstruction"/>

                        <div class="custom-container">
                          <template v-for="(simulationLot, index) in simulationLots">
                            <b-form-checkbox
                              :key="index*simulationLot.lotNumber  + '-checkbox-key'"
                              :checked="simulationConstruction.selectedLots && simulationConstruction.selectedLots.includes(simulationLot.id)"
                              @change="toggleLotSelection(simulationConstruction, simulationLot.id)"
                            >
                              {{ $t('SimulationLot') + ' ' + simulationLot.lotNumber }}
                            </b-form-checkbox>
                          </template>
                        </div>
                      </div>
                    </template>

                    <div class="row mt-2 mb-4">
                      <div class="col-md-12">
                        <span class="bold-text addLink"
                              @click="addSimulationConstructionGeneral(simulation, typeConstruction)"> + {{$t('Add')}} {{ $t(typeConstruction.text) }}</span>
                      </div>
                    </div>

                  </div>
                </b-col>
                <b-col v-for="(simulationLot, index) in simulationLots" v-if="currentLot === index"
                       :key="index + '-content-key'">
                  <div v-for="typeConstruction in typesConstruction">
                    <div class="row">
                      <div class="col-md-12">
                        <span class="section-subtitle">{{ $t(typeConstruction.text) }}</span>
                      </div>
                    </div>

                    <template v-for="simulationConstruction in simulationConstructions">
                      <simulation-construction-component
                        v-if="simulationConstruction.data.simulationLot != null && (simulationConstruction.data.simulationLot.id === simulationLot.id && simulationConstruction.selectedLots.length === 0 ) && simulationConstruction.data.typeConstruction.value === typeConstruction.value"
                        :simulation-construction="simulationConstruction.data"
                        :index="index"
                        :is-operation-linked="isOperationLinked"
                        :operation-id="operationId"
                        @didChangeValue="emitChangeValue"
                        @removedSimulationConstruction="removedSimulationConstruction"/>
                    </template>

                    <div class="row mt-2 mb-4">
                      <div class="col-md-12">
                        <span class="bold-text addLink"
                              @click="addSimulationConstruction(simulationLot, typeConstruction)"> + {{$t('Add') }} {{ $t(typeConstruction.text) }}</span>
                      </div>
                    </div>

                  </div>
                </b-col>
              </b-row>
            </b-container>

            <div class="d-flex justify-content-end">
              <b-button class="mr-3" variant="outline-primary" @click="back">{{ $t('Back') }}</b-button>
              <b-button type="submit" variant="primary">{{ $t('Save.and.Continue') }}</b-button>
            </div>
          </b-form>
        </b-card>
      </div>

      <div class="col-md-3">
        <SimulationBilanCardPrice
          :prices="totalPrices">
        </SimulationBilanCardPrice>
      </div>
    </div>

    <add-simulation-construction-modal
      ref="addSimulationConstructionModal"
      :simulation="selected.simulation"
      :simulationLot="selected.simulationLot"
      :type-construction="selected.typeConstruction"
      :unites-construction="unitesConstruction"
      @didAddSimulationConstruction="didAddSimulationConstruction"/>

  </div>

</template>

<script>

import api from '../../../services/api'
import AddSimulationConstructionModal from '../components/AddSimulationConstructionModal'
import SimulationConstructionComponent from '../components/SimulationConstructionComponent'
import SimulationBilanCardPrice from './components/SimulationBilanCardPrice.vue'
import SimulationLotNavigation from "../../../components/SimulationLotNavigation";

export default {

  name: 'SimulationConstructions',

  components: {
    SimulationBilanCardPrice,
    SimulationConstructionComponent,
    AddSimulationConstructionModal,
    SimulationLotNavigation
  },

  props: {
    simulationId: {
      type: Number,
      default: null
    },
    isOperationLinked: {
      type: Boolean,
      default: false
    },
    operationId: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      typesConstruction: [],
      unitesConstruction: [],
      simulationLots: [],
      currentLot: -1,
      simulation: null,
      simulationConstructions: [],
      simulationConstructionsIdsToRemove: [],
      selected: {
        simulation: null,
        simulationLot: null,
        typeConstruction: null
      },
      totalPrices: []
    }
  },

  emits: ['didContinueConstructions', 'didBack', 'didChangeValue'],

  mounted() {
    this.fetchData()
  },

  methods: {

    async fetchData() {
      await this.getTypesConstruction()
      await this.getUnitesConstruction()
      await this.getSimulationLots()
      await this.getSimulation()
      await this.getSimulationConstructions()
      await this.getTotalOfBilan()
    },

    async getTypesConstruction() {
      await api
        .get(`/simulationConstruction/getTypesConstruction`)
        .then(response => {
          this.typesConstruction = response.data
        })
    },

    async getUnitesConstruction() {
      await api
        .get(`/simulationConstruction/getUnitesConstruction`)
        .then(response => {
          this.unitesConstruction = response.data
          this.$refs.addSimulationConstructionModal.uniteConstruction = this.unitesConstruction[0].value
        })
    },

    async getSimulationLots() {
      if (this.simulationId != null) {
        await api
          .get(`/simulationLot/getAllForSimulation/${this.simulationId}`)
          .then(response => {
            this.simulationLots = response.data
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'SimulationIndex',
                params: {
                  message: error.response.data.message
                }
              })
            }
          })
      }
    },

    async getSimulation() {
      if (this.simulationId != null) {
        await api
          .get(`/simulation/${this.simulationId}`)
          .then(response => {
            this.simulation = response.data
          })
      }
    },

    async getSimulationConstructions() {
      if (this.simulationId != null) {
        await api
          .get(`/simulationConstruction/getAllForSimulation/${this.simulationId}`)
          .then(response => {
            const tempConstructions = {}

            response.data.forEach(construction => {
              if (construction.commonId && construction.commonId !== '') {
                if (!tempConstructions[construction.commonId]) {
                  tempConstructions[construction.commonId] = {
                    data: construction,
                    selectedLots: []
                  }
                }
                tempConstructions[construction.commonId].selectedLots.push(construction.simulationLot.id)
              } else {
                tempConstructions[construction.id] = {
                  data: construction,
                  selectedLots: construction.simulation.id ? this.simulationLots.map(lot => lot.id) : []
                }
              }
            })
            this.simulationConstructions = Object.values(tempConstructions)
            this.simulationConstructions.forEach(construction => {
              if (construction['data']['commonId'] != null) {
                construction['data']['prixParM2'] = Math.round(construction['data']['prixParM2'] * construction['selectedLots'].length)
                construction['data']['prixTTC'] = construction['data']['surface'] ? construction['data']['surface'] * construction['data']['prixParM2'] : construction['data']['prixParM2']
              }
            })
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'SimulationShow',
                params: {
                  simulationId: this.simulationId,
                  message: error.response.data.message
                }
              })
            }
          })
      }
    },

    async getTotalOfBilan() {
      await api
        .get(`/simulation/getTotalOfBilan/${this.simulationId}`)
        .then(response => {
          this.totalPrices = response.data
        })
    },

    async emitChangeValue() {
      this.$emit('didChangeValue')
    },

    addSimulationConstruction(simulationLot, typeConstruction) {
      this.selected.simulationLot = simulationLot
      this.selected.typeConstruction = typeConstruction
      this.$bvModal.show('add-simulation-construction-modal')
    },

    addSimulationConstructionGeneral(simulation, typeConstruction) {
      this.selected.simulation = simulation
      this.selected.typeConstruction = typeConstruction
      this.$bvModal.show('add-simulation-construction-modal')
    },

    async didAddSimulationConstruction(simulationConstruction) {
      let simulationLotsIds = []
      if (this.selected.simulation != null) {
        this.simulationLots.forEach(lot => {
          simulationLotsIds.push(lot.id)
        })
      }

      await this.createOrUpdateSimulationConstructions()

      let data = new FormData()
      if (this.selected.simulationLot != null) {
        data.append('simulationLotId', this.selected.simulationLot.id)
      }
      if (this.selected.simulation != null) {
        data.append('simulationId', this.selected.simulation.id)
        data.append('selectedLotsIds', simulationLotsIds)
      }
      data.append('name', simulationConstruction.name)
      data.append('typeConstruction', simulationConstruction.typeConstruction.value)
      data.append('uniteConstruction', simulationConstruction.uniteConstruction.value)
      data.append('surface', simulationConstruction.surface)
      data.append('prixParM2', simulationConstruction.prixParM2)

      try {
        await api({
          method: 'POST',
          url: 'simulationConstruction',
          data: data
        })

        await this.getSimulationConstructions()
      } catch (error) {
        console.error('Erreur lors de la création de la construction:', error)
        if (error.response.status === 401 || error.response.status === 404) {
          this.$router.push({
            name: 'SimulationIndex',
            params: {
              message: error.response.data.message
            }
          })
        }
      }

      this.selected.simulation = null
      this.selected.simulationLot = null
      this.selected.typeConstruction = null
      this.$refs.addSimulationConstructionModal.uniteConstruction = this.unitesConstruction[0].value
    },

    toggleLotSelection(simulationConstruction, lotId) {
      const index = simulationConstruction.selectedLots.indexOf(lotId)
      if (index === -1) {
        simulationConstruction.selectedLots.push(lotId)
      } else {
        simulationConstruction.selectedLots.splice(index, 1)
      }
    },

    removedSimulationConstruction(simulationConstruction) {
      if (simulationConstruction.id) {
        this.simulationConstructionsIdsToRemove.push(simulationConstruction.id)
      }
      let index = this.simulationConstructions.findIndex((obj) => JSON.stringify(obj.data) === JSON.stringify(simulationConstruction))

      if (index > -1) {
        this.simulationConstructions.splice(index, 1)
      }
    },

    back() {
      this.$confirm(this.$i18n.t('Back.confirm').toString()).then(() => {
        this.$emit('didBack')
      })
    },

    async onSubmit() {
      await this.createOrUpdateSimulationConstructions()
      await this.editSimulation()
      this.$emit('didContinueConstructions')
    },

    async createOrUpdateSimulationConstructions() {
      for (const simulationConstruction of this.simulationConstructions) {
        let data = new FormData()
        if (simulationConstruction.data.simulationLot != null) {
          data.append('simulationLotId', simulationConstruction.data.simulationLot.id)
        }
        if (simulationConstruction.data.simulation != null) {
          data.append('simulationId', simulationConstruction.data.simulation.id)
          data.append('selectedLotsIds', simulationConstruction.selectedLots)
        }
        data.append('name', simulationConstruction.data.name)
        data.append('typeConstruction', simulationConstruction.data.typeConstruction.value)
        data.append('uniteConstruction', simulationConstruction.data.uniteConstruction.value)
        data.append('surface', simulationConstruction.data.surface)
        data.append('prixParM2', simulationConstruction.data.prixParM2)

        let url = 'simulationConstruction'
        if (simulationConstruction.data.id) {
          url = '/simulationConstruction/' + simulationConstruction.data.id
        }

        await api({
          method: 'POST',
          url: url,
          data: data
        })
          .then(() => {
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'SimulationIndex',
                params: {
                  message: error.response.data.message
                }
              })
            }
          })
      }
    },

    async editSimulation() {
      let data = new FormData()
      data.append('constructionsCreationDone', true)

      api({
        method: 'POST',
        url: '/simulation/' + this.simulationId,
        data: data
      })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'SimulationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    }
  }
}

</script>

<style scoped>
.custom-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: -1em;
  flex-wrap: wrap;
}

.custom-container > * {
  white-space: nowrap;
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/simulation/createEditSteps/SimulationConstructions.vue